import { useEffect, useState } from "react";
import { X, ZoomIn, ZoomOut, RotateCcw, Loader2 } from "lucide-react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const ctrl = "flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition-colors hover:bg-[#C9A84C] hover:text-[#2C2C2C]";

export function ZoomLightbox({ src, alt, onClose }) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[100] bg-black/95" data-testid="menu-lightbox" role="dialog" aria-modal="true" aria-label={alt}>
      <TransformWrapper minScale={1} maxScale={6} doubleClick={{ mode: "toggle", step: 2.5 }} wheel={{ step: 0.15 }} centerOnInit>
        {({ zoomIn, zoomOut, resetTransform }) => (
          <>
            <TransformComponent wrapperStyle={{ width: "100vw", height: "100dvh" }} contentStyle={{ width: "100vw", height: "100dvh", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src={src} alt={alt} onLoad={() => setLoaded(true)} data-testid="menu-lightbox-image" className={`max-h-[100dvh] max-w-[100vw] select-none object-contain p-2 transition-opacity duration-300 sm:p-6 ${loaded ? "opacity-100" : "opacity-0"}`} draggable={false} />
            </TransformComponent>
            {!loaded && (
              <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-3 text-white/80" data-testid="menu-lightbox-loader">
                <Loader2 size={34} className="animate-spin text-[#C9A84C]" />
                <span className="text-sm">Chargement de la carte…</span>
              </div>
            )}
            <button onClick={onClose} aria-label="Fermer" data-testid="menu-lightbox-close" className={`${ctrl} absolute right-4 top-4 z-10`}><X size={24} /></button>
            <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 items-center gap-3">
              <button onClick={() => zoomOut()} aria-label="Dézoomer" data-testid="menu-lightbox-zoom-out" className={ctrl}><ZoomOut size={20} /></button>
              <button onClick={() => resetTransform()} aria-label="Taille initiale" data-testid="menu-lightbox-reset" className={ctrl}><RotateCcw size={18} /></button>
              <button onClick={() => zoomIn()} aria-label="Zoomer" data-testid="menu-lightbox-zoom-in" className={ctrl}><ZoomIn size={20} /></button>
            </div>
            <p className="pointer-events-none absolute left-1/2 top-6 z-10 hidden -translate-x-1/2 text-xs text-white/60 sm:block">Molette ou double-clic pour zoomer · glisser pour se déplacer</p>
          </>
        )}
      </TransformWrapper>
    </div>
  );
}
